import React from 'react';
import { FaDesktop, FaTimes } from 'react-icons/fa';

// Viewports narrower than this are treated as phones.
export const MOBILE_MAX_WIDTH = 768;

export const isMobileViewport = () => window.innerWidth < MOBILE_MAX_WIDTH;

// Router state key that opens /onboarding directly on its desktop-only step.
export const DESKTOP_ONLY_STATE = 'desktopOnly';

// "Works best on desktop" notice for phone visitors on the login page.
const DesktopOnlyPopup = ({ onClose, onBookDemo }) => (
    <div
        className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4 backdrop-blur-[6px]"
        onClick={onClose}
        role="presentation"
    >
        <div
            className="relative flex w-full max-w-[400px] flex-col gap-4 overflow-hidden rounded-[24px] bg-white p-5 shadow-[0_24px_60px_-12px_rgba(27,40,51,0.25),4px_46px_134px_14px_rgba(96,146,200,0.15)] sm:p-6"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-labelledby="desktop-only-popup-title"
        >
            <button
                type="button"
                onClick={onClose}
                aria-label="Close"
                className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center text-[18px] text-[#505050] transition hover:opacity-70"
            >
                <FaTimes />
            </button>

            <div className="flex items-center gap-3 pr-8">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#E9F6FF] text-[20px] text-[#2766AA]">
                    <FaDesktop />
                </span>
                <p className="!mb-0 font-heading text-[18px] font-medium leading-tight text-[#2766AA]">
                    Almost there
                </p>
            </div>

            <div className="flex flex-col gap-1">
                <h2
                    id="desktop-only-popup-title"
                    className="!mb-0 font-heading text-[20px] font-semibold leading-tight text-[#3A3A3A]"
                >
                    EcomBuddha is built for desktop
                </h2>
                <p className="!mb-0 text-[15px] font-medium leading-[1.4] text-[#737373]">
                    Log in from a laptop or desktop to use EcomBuddha.
                </p>
            </div>

            <div className="mt-1 flex gap-3">
                <button
                    type="button"
                    onClick={onClose}
                    className="inline-flex h-[46px] flex-1 items-center justify-center whitespace-nowrap rounded-2xl bg-[#E9F6FF] px-2 text-[16px] font-semibold text-[#2766AA] transition hover:opacity-90"
                >
                    Okay
                </button>
                <button
                    type="button"
                    onClick={onBookDemo}
                    className="inline-flex h-[46px] flex-1 items-center justify-center whitespace-nowrap rounded-2xl bg-[linear-gradient(119deg,#2766AA_0%,#0752B0_100%)] px-2 text-[16px] font-semibold text-white transition hover:brightness-105"
                >
                    Book a Demo
                </button>
            </div>
        </div>
    </div>
);

export default DesktopOnlyPopup;
